var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Form, Input, Loader, Message } from "semantic-ui-react";
import { postWithAuthn } from "../RequestHelpers";
var AddCommentModal = /** @class */ (function (_super) {
    __extends(AddCommentModal, _super);
    function AddCommentModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onCommentChange = function (event) {
            var val = event.currentTarget.value;
            _this.setState({
                msg: val
            });
        };
        _this.addAttachment = function (event, _) {
            var list = event.currentTarget.files;
            if (list === null || list.length === 0) {
                return;
            }
            var attachmentFiles = Array.from(list);
            _this.setState(function (prevState) {
                return {
                    attachments: prevState.attachments.concat(attachmentFiles)
                };
            });
        };
        _this.removeAttachment = function (fileName) {
            return function () {
                _this.setState(function (prevState) {
                    return {
                        attachments: prevState.attachments.filter(function (a) { return a.name !== fileName; })
                    };
                });
            };
        };
        _this.submitComment = function () {
            _this.setState({
                loading: true,
                success: false,
                error: false
            }, function () {
                var formData = new FormData();
                _this.state.attachments.forEach(function (p, index) {
                    formData.append("attachment-" + index, p);
                });
                formData.append("msg", _this.state.msg);
                postWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/comment", formData)
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true,
                            msg: "",
                            attachments: []
                        }, _this.props.onSubmit);
                    }
                    else {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't submit comment: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            error: false,
            msg: '',
            attachments: []
        };
        return _this;
    }
    AddCommentModal.prototype.render = function () {
        var _this = this;
        return React.createElement(Dimmer.Dimmable, { as: Form },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(Form.Field, null,
                React.createElement(Form.TextArea, { onChange: this.onCommentChange, value: this.state.msg })),
            this.state.attachments.length,
            " Attachments selected",
            this.state.attachments.map(function (f, index) {
                return React.createElement("div", { key: index },
                    "Attachment #",
                    index + 1,
                    ": ",
                    f.name,
                    " ",
                    React.createElement(Button, { icon: "x", color: 'red', size: 'mini', onClick: _this.removeAttachment(f.name) }));
            }),
            React.createElement("div", null,
                React.createElement("p", null, "File types supported are: .pdf, .jpeg, .png, .dna, .txt, .xlsx, .docx"),
                React.createElement(Input, { type: 'file', onChange: this.addAttachment, multiple: true })),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Comment added."),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Comment could not be added."),
            React.createElement("br", null),
            React.createElement(Button, { disabled: this.state.msg.length === 0, icon: 'comment', label: 'Add comment', labelPosition: 'left', onClick: this.submitComment, positive: true }));
    };
    return AddCommentModal;
}(React.PureComponent));
export default AddCommentModal;
//# sourceMappingURL=AddOrderComment.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AddOrderComment.js
// module id = 1241
// module chunks = 0